import React from "react";
import { Link } from "react-router-dom";

const ServiceCard = ({ service }) => {
  const { _id, fabImage, serviceTitle } = service;

  return (
    <Link to={`/serviceList/${_id}`} className="card  bg-base-100 shadow-xl">
      {fabImage.search("http") > -1 && (
        <figure className="block h-[100%]">
          <img
            src={fabImage}
            alt={fabImage + " " + "Image"}
            className="min-h-[275px] object-cover w-full"
          />
        </figure>
      )}
      <div className="card-body">
        <h2 className="text-2xl font-semibold text-center">{serviceTitle}</h2>
      </div>
    </Link>
  );
};

export default ServiceCard;
